var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalStepsImg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 39.1667H2.50016C2.05814 39.1667 1.63421 38.9911 1.32165 38.6786C1.00909 38.366 0.833496 37.9421 0.833496 37.5V2.50004C0.833496 2.05801 1.00909 1.63409 1.32165 1.32153C1.63421 1.00897 2.05814 0.833374 2.50016 0.833374H24.6552C25.0972 0.833468 25.521 1.00913 25.8335 1.32171L32.0118 7.50004C32.3244 7.81253 32.5001 8.23638 32.5002 8.67837V15.8334",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 23.1816L12.4233 18.2583C12.6589 18.0232 12.9684 17.8769 13.2995 17.8441C13.6307 17.8113 13.9629 17.894 14.24 18.0783L16.5617 19.6266C16.8452 19.8154 17.1865 19.8976 17.5249 19.8585C17.8633 19.8195 18.1769 19.6617 18.41 19.4133L22.9733 14.5449",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8334V27.5H15",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7685 38.91C29.6907 38.9911 29.5973 39.0557 29.4939 39.0999C29.3905 39.144 29.2793 39.1667 29.1668 39.1667C29.0544 39.1667 28.9432 39.144 28.8398 39.0999C28.7364 39.0557 28.643 38.9911 28.5652 38.91L20.6435 30.6466C19.8952 29.8981 19.4013 28.9331 19.2317 27.8883C19.0621 26.8435 19.2254 25.7718 19.6985 24.825C20.056 24.1103 20.5781 23.4909 21.2219 23.0176C21.8658 22.5443 22.6128 22.2308 23.4016 22.1029C24.1903 21.975 24.9982 22.0363 25.7586 22.2818C26.519 22.5273 27.2102 22.95 27.7752 23.515L29.1668 24.9066L30.5585 23.515C31.1235 22.95 31.8147 22.5273 32.5751 22.2818C33.3355 22.0363 34.1434 21.975 34.9321 22.1029C35.7209 22.2308 36.4679 22.5443 37.1117 23.0176C37.7556 23.4909 38.2777 24.1103 38.6352 24.825C39.1083 25.7718 39.2716 26.8435 39.102 27.8883C38.9324 28.9331 38.4385 29.8981 37.6902 30.6466L29.7685 38.91Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalStepsImg3);
export default __webpack_public_path__ + "static/media/legalStepsImg3.9d1a88c2ae31edbb8eca74bafd8b6c91.svg";
export { ForwardRef as ReactComponent };